<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{ $t("costModel.title") }}
            <!-- {{data}} -->
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <br />
        <v-card-text>
          <v-container>
            <v-form v-model="valid" ref="form">
              <v-row>
                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-autocomplete
                    :items="typePlace"
                    filled
                    :label="$t('resorce.newPopup.type')"
                    outlined
                    dense
                    v-model="data.type"
                    item-text="title"
                    :rules="[rules.required]"
                    item-value="title"
                    class="ma-0 pa-0"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-autocomplete
                    :items="currencies"
                    filled
                    :label="$t('costModel.currency')"
                    outlined
                    :rules="[rules.required]"
                    dense
                    v-model="currencyCecked"
                    item-text="en_currency"
                    return-object
                    class="ma-0 pa-0"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1 pa-0"
                    v-model="data.cityBaseCosts"
                    :prefix="
                      $i18n.locale == 'ar'
                        ? currencyCecked.ar_currency
                        : currencyCecked.en_currency
                    "
                    :label="$t('costModel.cityBaseCosts')"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    v-model="data.costPerKg"
                    :prefix="
                      $i18n.locale == 'ar'
                        ? currencyCecked.ar_currency
                        : currencyCecked.en_currency
                    "
                    :rules="[rules.required]"
                    :label="$t('costModel.costPerKg')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    v-model="data.weight"
                    :rules="[rules.required]"
                    :label="$t('costModel.weight')"
                    prefix="kg"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1"
                    v-model="data.costPerKilometer"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    :rules="[rules.required]"
                    :label="$t('costModel.costPerKilometer')"
                    :prefix="
                      $i18n.locale == 'ar'
                        ? currencyCecked.ar_currency
                        : currencyCecked.en_currency
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1"
                    required
                    v-model="data.expressServiceFee"
                    :prefix="
                      $i18n.locale == 'ar'
                        ? currencyCecked.ar_currency
                        : currencyCecked.en_currency
                    "
                    :rules="[rules.required]"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    :label="$t('costModel.expressServiceFee')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1"
                    required
                    prefix="%"
                    :rules="[rules.required]"
                    v-model="data.taxRate"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    :label="$t('costModel.taxRate')"
                  ></v-text-field>
                </v-col> </v-row
            ></v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="close">
            {{ $t("btn.cancel") }}
          </v-btn>

          <v-btn
            color="primary"
            :dark="!clicked"
            @click="submit()"
            :disabled="clicked"
          >
            {{ $t("btn.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import cl from "@/services/costModel.js";
export default {
  data: () => {
    return {
      valid: true,
      currencies: [
        {
          en_currency: "Dollar",
          ar_currency: "دولار",
        },
        {
          en_currency: "Euro",
          ar_currency: "يورو",
        },
        {
          en_currency: "EGP",
          ar_currency: "جنيه",
        },
        {
          en_currency: "DZ",
          ar_currency: "دينار",
        },
      ],
      currencyCecked: {
        en_currency: "Dollar",
        ar_currency: "دولار",
      },
      data: {
        type: "",
        costPerKilometer: "",
        costPerKg: "",
        expressServiceFee: "",
        taxRate: "",
        cityBaseCosts: "",
        en_currency: "dollar",
        ar_currency: "دولار",
        weight: "",
      },
      clicked: false,
      rules: {
        required: null,
      },
    };
  },

  created() {
    this.rules.required = (v) => !!v || this.$t("rules.require");
  },
  props: {
    dialog: { type: Boolean, default: () => false },
    SRC: { type: Object, default: () => {} },
  },

  computed: {
    ...mapState(["typePlace"]),
  },
  methods: {
    close() {
      if (this.update == false) this.$refs.form.reset();
      this.$emit("close-dialog", false);
    },

    submit() {
      this.$refs.form.validate();
      if (this.valid == false) return;
      this.clicked = true;
      let payload = this.data;
      payload.en_currency = this.currencyCecked.en_currency;
      payload.ar_currency = this.currencyCecked.ar_currency;
      payload.src_id = this.SRC.id;
      cl.addOne(payload)
        .then((res) => {
          // this.$refs.form.reset();
          this.$store.dispatch(
            "api/handleServiceException",
            { e: res },
            { root: true }
          );

          this.$emit("close-dialog", false);
          this.clicked = false;
        })
        .catch((err) => {
          this.$store.dispatch(
            "api/handleServiceException",
            { e: err },
            { root: true }
          );

          this.clicked = false;
        });
    },
  },
};
</script>
